import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { TextField } from '@material-ui/core'
import { Button } from 'reactstrap'
import _ from 'lodash'
import Cookies from 'js-cookie'
import Axios from 'axios'

import LoadingModal from 'components/Indicator/LoadingOverlay'
import StatusModal from 'components/Modal/status'
import { CaptchaContextProvider, useCaptchaContext } from 'components/ContextWrapper/captcha'
import Captcha from "components/Captcha"
import { getItem } from 'utils/tokenStore'
import { ApplyBranding } from 'utils/apply-color'
import { login } from 'actions/login'
import { getUserProfile } from 'actions/profile'
import { getDictionary } from 'actions/dictionary'
import { getSelectedRole } from 'actions/role'
import { getPlatformConfig } from 'actions/platformConfig'
import { initAjaxCall } from 'actions/ajax';
import BackdropImage from 'assets/images/backdrop-image.jpg';
import TennisBackdropImage from 'assets/images/tennis.jpg'

import './index.scss';

const Login = props => {
  const { buttonDisabled, setButtonDisabled } = useCaptchaContext()
  const [ state, setState ] = useState({
    email: '',
    password: '',
    statusModal: false,
    accountLockIntervalId: 0
  })

  useEffect(() => {
    if( Cookies.get( 'SHOW_OUTDATED_TOKEN' ) && Cookies.get( 'SHOW_OUTDATED_TOKEN' ) === 'true' ) {
      Cookies.set( 'SHOW_OUTDATED_TOKEN', 'false' )
    }
    localStorage.getItem( 'IS_TOKEN_EXPIRED' ) && setState({ ...state, statusModal: true })
    getPlatformConfig()
  }, [])

  useEffect(() => {
    if( !props.data.ajaxReducer.ajaxCallProgress && !_.isEmpty( getItem( 'PROOFPOINT_ARK_MANAGEMENT' ) ) ) {
      Axios.defaults.headers = {
        common : {
          Authorization: `${ getItem( 'PROOFPOINT_ARK_MANAGEMENT' ) }`
        }
      }
      if( !props.data.ajaxReducer.ajaxErrorMessage && _.isEmpty( props.data.profileReducer.profile ) ) {
        props.getUserProfile()
      } else {
        let params = new URLSearchParams( window.location.hash.substring( 2 ) )
        props.history.push( 
          params.get( 'prev' ) 
            ? params.get( 'prev' ).substring( 1 )
            : '/dashboard' 
        )
      }
    }

    if( 
      props.data.ajaxReducer.ajaxCallProgress !== 1 &&
      props.data.ajaxReducer.ajaxErrorMessage && 
      props.data.ajaxReducer.ajaxErrorMessage.length > 0 
    ){
      setState({ ...state, statusModal: true })
    }
  }, [ props.data.ajaxReducer ])

  const onClickLogin = ( email, password ) => props.login({ 
    email, 
    password, 
    platform: 'ark-management',
    accountLockIntervalId: state.accountLockIntervalId,
    onChangeAccountLockIntervalId: ( intervalId ) => setState({ ...state, accountLockIntervalId: intervalId })
  })

  const handleForgotPassword = () =>  props.history.push( '/forgot-password' )

  const handleKeyPress = ( event, email, password ) => {
    if( event.key === 'Enter' && !buttonDisabled ){
      props.login({ 
        email, 
        password, 
        platform: 'ark-management',
        accountLockIntervalId: state.accountLockIntervalId,
        onChangeAccountLockIntervalId: ( intervalId ) => setState({ ...state, accountLockIntervalId: intervalId })
      })
    }
  }

  return (
    <>
      {
        !_.isEmpty( props.data.platformConfigReducer.platformConfig ) 
        && _.find( props.data.platformConfigReducer.platformConfig, { key: 'PLATFORM_COLOR' } )
        && <ApplyBranding colors={{ primary: _.find( props.data.platformConfigReducer.platformConfig, { key: 'PLATFORM_COLOR' } ).value }} />
      }
      <form className="login">
        <img src={ window.location.host.indexOf( 'tennis' ) > -1 ? TennisBackdropImage : BackdropImage } className="bg-image" />
        <div className="login-overlay">
          <div className="login-panel">
            <h1 className="login-panel-title">Willkommen, Loggen Sie sich ein</h1>
            <TextField
              error={ props.data.ajaxReducer.ajaxErrorMessage && props.data.ajaxReducer.ajaxErrorMessage.email ? true : false }
              helperText={ props.data.ajaxReducer.ajaxErrorMessage && props.data.ajaxReducer.ajaxErrorMessage.email ? props.data.ajaxReducer.ajaxErrorMessage.email : '' }
              label={ 'Email' }
              value={ state.email }
              onChange={ e => setState({ ...state, email: e.target.value }) }
              type={ 'email' }
              className={ 'kws-input mb-15' }
              onKeyPress={ handleKeyPress } />
            <TextField
              error={ props.data.ajaxReducer.ajaxErrorMessage && props.data.ajaxReducer.ajaxErrorMessage.password ? true : false }
              helperText={ props.data.ajaxReducer.ajaxErrorMessage && props.data.ajaxReducer.ajaxErrorMessage.password ? props.data.ajaxReducer.ajaxErrorMessage.password : '' }
              label={ 'Passwort' }
              value={ state.password }
              onChange={ e => setState({ ...state, password: e.target.value }) }
              type={ 'password' }
              className={ 'kws-input mb-30' }
              onKeyPress={ event => handleKeyPress( event, state.email, state.password ) } />
            <div className='d-flex flex-row justify-content-between flex-wrap'>
              <div className='d-flex flex-row flex-wrap'>
                <Button
                  className='mb-2'
                  color={'primary'}
                  style={{ height: "fit-content" }}
                  disabled={ buttonDisabled }
                  onClick={ () => onClickLogin( state.email, state.password ) }>
                  {'Anmeldung'}
                </Button>
                <Button
                  className='mb-2'
                  color={'link'}
                  style={{ height: "fit-content" }}
                  onClick={handleForgotPassword}>
                  {'Passwort vergessen'}
                </Button>
              </div>
              <div 
                style={{ flex: "1" }}
                className='d-flex flex-row justify-content-end mb-2'>
                <Captcha
                  lang='de'
                  onHandleDone={ () => setButtonDisabled( false ) }
                  onHandleError={ () => {} }
                />
              </div>
            </div>
          </div>
          <StatusModal
            isOpen={ state.statusModal }
            type={ 'negative' }
            message={ localStorage.getItem( 'IS_TOKEN_EXPIRED' )
              ? 'Ihre Sitzung ist abgelaufen'
              : props.data.ajaxReducer
                ? props.data.ajaxReducer.ajaxErrorMessage 
                : ''
            }
            onClick={ () => {
              if ( state.accountLockIntervalId > 0 ) {
                clearInterval( state.accountLockIntervalId )
                props.initAjaxCall()
              }
              setState({ 
                ...state, 
                accountLockIntervalId: 0,
                statusModal: false 
              }) 
              localStorage.getItem( 'IS_TOKEN_EXPIRED' ) && window.localStorage.removeItem( 'IS_TOKEN_EXPIRED' )
            }} 
          />
        </div>
        { props.data.ajaxReducer.ajaxCallProgress > 0 && <LoadingModal /> }
      </form>
    </>
  )
}

const mapStateToProps = state => ({ data: state })

export default connect( mapStateToProps, {
  login,
  getUserProfile,
  getDictionary,
  getSelectedRole,
  getPlatformConfig,
  initAjaxCall
})( 
  props => (
    <CaptchaContextProvider>
      <Login {...props} />
    </CaptchaContextProvider> 
  )
);
